const measure = {
  narrow: "16em",
  base: "28em",
  wide: "40em"
};

export default measure;
